import * as fs from "fs";
import * as ko from "knockout";
import * as moment from "moment";
import { Utils } from "../../utils";
import { RNSAPI } from "../../api";
import { Postbox, PostboxPaging } from '../postbox/postbox';
import './dialog';
import './message';
import { MainViewModel } from "../../main";
export class resubmissionDialogViewModel {
    givenId = "NewDeadlineDialogExt";
    PregiID = "fristDeadlinePrelineDate";
    deadlineNr = ko.observable("");
    predeadlineNr = ko.observable("");
    deadlineCreationDate = ko.observable(moment().format("YYYY-MM-DD"));
    deadlinePrelineDate = ko.computed(() => {
        let predead = moment(ko.toJS(this.FristTemp), "YYYY-MM-DD").subtract(7, "day");
        if (ko.toJS(this.predeadlineNr) !== '') {
            predead = moment(ko.toJS(this.FristTemp), "YYYY-MM-DD").subtract(parseInt(ko.toJS(this.predeadlineNr)), "day");
        }
        return predead.format("YYYY-MM-DD");
    });
    akteFrist = this.newAkteFrist();
    infoMessage = ko.observable('');
    infoTitle = ko.observable('');
    modalHandleSelection = ko.observable();
    modalTitle = ko.observable("");
    modalKeys = ko.observableArray([]);
    modalColumns = ko.observableArray([]);
    modalData = ko.observableArray([]);
    fKAId = ko.observable('');
    fkAName = ko.observable('');
    isAfterFrist = ko.observable(false);
    savedSuccessfull = ko.observable(false);
    showOutlookLoader = ko.observable(false);
    showError = ko.observable(false);
    showErrorOfInstances = ko.observable(false);
    showSuccess = ko.observable(false);
    isSelected = ko.observable(false);
    showDifferentCalculation = ko.observable(false);
    movedForward = ko.observable(false);
    isVerificationReason = ko.observable(false);
    calculateLikePreDeadline = ko.observable(false);
    attendeesType() {
        let obj = {
            EMailAddress: ko.observable(''),
            IsRequired: true
        };
        return obj;
    }
    attendeesOfSBs = ko.observableArray([]);
    InstanceInCase = ko.observableArray([]);
    FristTemp = ko.observable(moment().format("YYYY-MM-DD"));
    pastFristApproved = ko.observable(false);
    gerCase = ko.observable('');
    movedDeadlineText = ko.observable("");
    movedPreDeadlineText = ko.observable("");
    deactivateCalculation = ko.observable(false);
    PreDeadlines = ko.observableArray([]);
    PreDeadlinesLength = ko.observable(0);
    viewWithoutModal = ko.observable(false);
    isStack = ko.observable(false);
    stackId = ko.observable(null);
    instanceIdFromParameter = ko.observable(0);
    currentMailMessageId = ko.observable(null);
    currentAttachmentId = ko.observable(0);
    stackIndex = ko.observable(null);
    calculatedDates = ko.observable(null);
    initalizedState = ko.observable(false);
    deadlineReasons = ko.observableArray([]);
    showDeadlineReasons = ko.observable(false);
    remainingNotizenChars = ko.computed(() => {
        const frist = ko.toJS(this.akteFrist);
        const text = frist?.Notizen || "";
        return `${200 - text.length} Zeichen übrig`;
    });
    suppressDeadlineCalculation = ko.observable(false);
    newAkteFrist() {
        let obj = {
            SachbearbeiterId: ko.observable(RNSAPI.User().username),
            Sachbearbeiter: ko.observable(null),
            Clerk: ko.observable(null),
            CaseId: ko.observable(null),
            Rubrum: ko.observable("Kein Rubrum vorhanden."),
            DeadlineNumber: ko.observable("-/-"),
            DeadlineText: ko.observable(null),
            TypeId: ko.observable(""),
            TypeDescription: ko.observable(""),
            AddressKeyword: ko.observable(""),
            CompletedBy: ko.observable(""),
            CompletionDate: ko.observable(""),
            CreatedBy: ko.observable(""),
            StartDate: ko.observable(moment().format("YYYY-MM-DD")),
            Notizen: ko.observable(""),
            Note: ko.observable(""),
            Deadline: ko.observable("YYYY-MM-DD"),
            PreDeadline: ko.observable('YYYY-MM-DD'),
            State: ko.observable(""),
            Attendees: ko.observableArray([]),
            NotifySB: ko.observable(false),
            OutlookExport: ko.observable(false),
            InstanceId: ko.observable(""),
            PreDeadlines: ko.observableArray([]),
            IsStack: ko.observable(false),
            MailMessageId: ko.observable(null),
            stackId: ko.observable(null),
            AttachmentId: ko.observable(0)
        };
        return ko.observable(obj);
    }
    newNotifyObj() {
        let obj = {
            CaseId: ko.observable(""),
            TypeId: ko.observable(""),
            TypeDescription: ko.observable(""),
            Clerk: ko.observable(""),
            Deadline: ko.observable("")
        };
        return ko.observable(obj);
    }
    async pickGeneric(title, keys, columns, data) {
        this.modalTitle(title);
        this.modalKeys(keys);
        this.modalColumns(columns);
        this.modalData(data);
    }
    async postFrist() {
        this.postFristData();
    }
    async closeModal() {
        $("#" + this.givenId).modal("hide");
        if (document.URL.includes("easycase"))
            window.location.reload();
    }
    newCalculationCall() {
        let obj = {
            StartDate: ko.observable(ko.toJS(this.deadlineCreationDate)),
            DeadlineNumber: ko.observable(ko.toJS(this.akteFrist().DeadlineNumber)),
            State: ko.observable(ko.toJS(this.akteFrist().State))
        };
        return ko.observable(obj);
    }
    newCalculationDeadlineCall() {
        let obj = {
            StartDate: ko.observable(ko.toJS(this.akteFrist().Deadline)),
            DeadlineNumber: ko.observable(ko.toJS(this.akteFrist().DeadlineNumber)),
            State: ko.observable(ko.toJS(this.akteFrist().State))
        };
        return ko.observable(obj);
    }
    setMovedText(form, pred, rawForm, rawPred) {
        if (rawForm !== form)
            this.movedDeadlineText("Verlegt vom " + moment(rawForm).format("DD.MM.yyyy"));
        else
            this.movedDeadlineText("");
        if (rawPred !== pred)
            this.movedPreDeadlineText("Verlegt vom " + moment(rawPred).format("DD.MM.yyyy"));
        else
            this.movedPreDeadlineText("");
        if (ko.toJS(this.deadlineNr) === "")
            this.deactivateCalculation(true);
        this.akteFrist().Deadline(form);
        this.akteFrist().PreDeadline(pred);
        if (ko.toJS(this.deadlineNr) === "")
            this.deactivateCalculation(false);
    }
    newCalculationisHolidayCall() {
        let obj = {
            Deadline: ko.observable(ko.toJS(this.akteFrist().Deadline)),
            Predeadline: ko.observable(ko.toJS(this.akteFrist().PreDeadline)),
            State: ko.observable(ko.toJS(this.akteFrist().State))
        };
        return ko.observable(obj);
    }
    async calulateFristWithParameters(fromFunction = false) {
        this.deactivateCalculation(true);
        if (ko.toJS(this.deadlineCreationDate) !== '' && ko.toJS(this.akteFrist().DeadlineNumber) !== "-/-" && ko.toJS(this.akteFrist().State) !== '') {
            if (ko.toJS(this.isStack) === false && !fromFunction) {
                let res = (await RNSAPI.calcDeadline(ko.toJS(this.newCalculationCall())));
                if (res.Type === "CalculationResult") {
                    const deadline = res.Payload.Deadline;

                    this.PreDeadlines([]);
                    this.PreDeadlinesLength(0);

                    if (Array.isArray(deadline.PreDeadlines)) {
                        for (const preDeadline of deadline.PreDeadlines) {
                            this.addPreDeadline(preDeadline);
                        }
                    }

                    this.setMovedText(
                        deadline.Deadline.split('T')[0],
                        deadline.PreDeadline.split('T')[0],
                        deadline.RawDeadline.split('T')[0],
                        deadline.RawPreDeadline.split('T')[0]
                    );
                }
            }
            else {
                if (ko.toJS(this.akteFrist().State) !== "0") {
                    if (ko.toJS(this.initalizedState) === false && ko.toJS(this.isStack) === true) {
                        this.initalizedState(true);
                        this.setMovedText(ko.toJS(this.calculatedDates).CalculatedDate.split('T')[0], ko.toJS(this.calculatedDates).PreDeadline.split('T')[0], ko.toJS(this.calculatedDates).RawDate.split('T')[0], ko.toJS(this.calculatedDates).RawPreDeadline.split('T')[0]);
                    }
                    else {
                        let res = (await RNSAPI.isDeadlineHoliday(ko.toJS(this.newCalculationisHolidayCall())));
                        if (res.Type === "CalculationResult") {
                            let form = res.Payload.Deadline.Deadline.split('T')[0];
                            let pred = res.Payload.Deadline.PreDeadline.split('T')[0];
                            let rawForm = res.Payload.Deadline.RawDeadline.split('T')[0];
                            let rawPred = res.Payload.Deadline.RawPreDeadline.split('T')[0];
                            let movedForward = res.Payload.Deadline.SkippedForward;
                            if (rawForm !== form) {
                                this.movedDeadlineText("Verlegt vom " + moment(rawForm).format("DD.MM.yyyy"));
                                if (movedForward)
                                    this.movedForward(true);
                            }
                            else {
                                this.movedDeadlineText("");
                                this.movedForward(false);
                            }
                            if (rawPred !== pred)
                                this.movedPreDeadlineText("Verlegt vom " + moment(rawPred).format("DD.MM.yyyy"));
                            else
                                this.movedPreDeadlineText("");
                            this.PreDeadlines([]);
                            this.PreDeadlinesLength(0);
                            for (let preDeadline of res.Payload.Deadline.PreDeadlines)
                                this.addPreDeadline(preDeadline);
                        }
                    }
                }
            }
        }
        this.deactivateCalculation(false);
    }
    async calulateFristWithDeadline() {
        if (!ko.toJS(this.deactivateCalculation)) {
            if (ko.toJS(this.deadlineNr) === "") {
                if (ko.toJS(this.deadlineCreationDate) !== '' && ko.toJS(this.akteFrist().DeadlineNumber) !== "-/-" && ko.toJS(this.akteFrist().State) !== '') {
                    if (ko.toJS(this.isStack) === false) {
                        let res = (await RNSAPI.calcDeadline(ko.toJS(this.newCalculationDeadlineCall())));
                        if (res.Type === "CalculationResult") {
                            let form = res.Payload.Deadline.Deadline.split('T')[0];
                            let pred = res.Payload.Deadline.PreDeadline.split('T')[0];
                            let rawForm = res.Payload.Deadline.RawDeadline.split('T')[0];
                            let rawPred = res.Payload.Deadline.RawPreDeadline.split('T')[0];
                            if (rawForm !== form)
                                this.movedDeadlineText("Kein Werktag (nächster Termin: " + moment(form).format("DD.MM.yyyy") + ")");
                            else
                                this.movedDeadlineText("");
                            if (rawPred !== pred)
                                this.movedPreDeadlineText("Verlegt vom " + moment(rawPred).format("DD.MM.yyyy"));
                            else
                                this.movedPreDeadlineText("");
                            this.deactivateCalculation(true);
                            this.akteFrist().Deadline(rawForm);
                            this.akteFrist().PreDeadline(pred);
                            this.deactivateCalculation(false);
                        }
                    }
                    else
                        this.calulateFristWithParameters(true);
                }
            }
            else
                this.calulateFristWithParameters(true);
        }
    }
    async setParamsForInstance() {
        for (let i = 0; i < this.InstanceInCase().length; i++) {
            if (ko.toJS(this.InstanceInCase)[i].InstanceId === ko.toJS(this.akteFrist().InstanceId)) {
                if (RNSAPI.getCurrentLoggedInUser().StateForCalculation === "" || RNSAPI.getCurrentLoggedInUser().StateForCalculation === null) {
                    this.setBLInstance(ko.toJS(this.InstanceInCase)[i].CourtId);
                    this.gerCase(ko.toJS(this.InstanceInCase)[i].CourtId);
                }
                else {
                    this.setFixBL();
                    this.gerCase('');
                }
            }
        }
    }
    async editPastFrist() {
        this.pastFristApproved(false);
        $("#" + ko.toJS(this.givenId) + "Deadline_Body").removeClass("hide");
        $("#" + ko.toJS(this.givenId) + "Deadline_Body").addClass("show");
        $("#" + ko.toJS(this.givenId) + "approvePastDeadlineBody").removeClass("show");
        $("#" + ko.toJS(this.givenId) + "approvePastDeadlineBody").addClass("hide");
    }
    async postFristData() {
        try {
            this.showError(false);
            $(".form-group").each(function () {
                $(this).removeClass("has-error");
            });
            if (!Utils.checkErrors(["CaseId"], this.akteFrist(), "deadline", [Utils.checkString]))
                return;
            if (ko.toJS(this.InstanceInCase).length === 0) {
                this.showErrorOfInstances(true);
                return;
            }
            else
                this.showErrorOfInstances(false);
            let deadlineObj = ko.toJS(this.akteFrist());
            if (ko.toJS(this.fKAId())) {
                deadlineObj.OutlookExport = (<HTMLInputElement>document.getElementById(ko.toJS(this.givenId) + 'exportToFKA')).checked;
                deadlineObj.NotifySB = (<HTMLInputElement>document.getElementById(ko.toJS(this.givenId) + 'notifyClerk')).checked;
            }
            deadlineObj.StartDate = moment(ko.toJS(this.deadlineCreationDate), "YYYY-MM-DD").format("YYYY-MM-DD");
            deadlineObj.Deadline = moment(deadlineObj.Deadline, "YYYY-MM-DD").format("YYYY-MM-DD");
            deadlineObj.PreDeadline = moment($("#" + this.PregiID).val(), "YYYY-MM-DD").format("YYYY-MM-DD");
            let invalid = false;
            const isValidStrict = (d: string) => moment(d, "YYYY-MM-DD", true).isValid();
            if (!isValidStrict(deadlineObj.StartDate)) {
                $("#" + ko.toJS(this.givenId) + "deadlineStartDate").closest('.form-group').addClass("has-error");
                invalid = true;
            }
            if (!isValidStrict(deadlineObj.Deadline)) {
                $("#" + ko.toJS(this.givenId) + "deadlineDeadlineDate").closest('.form-group').addClass("has-error");
                invalid = true;
            }
            if (!isValidStrict(deadlineObj.PreDeadline)) {
                $("#" + this.PregiID).closest('.form-group').addClass("has-error");
                invalid = true;
            }
            if (invalid) {
                return;
            }
            for (let i = 0; i < this.PreDeadlines().length; i++) {
                let MultiplePreDeadline = moment($("#" + this.PregiID + "_" + i).val(), "YYYY-MM-DD").format("YYYY-MM-DD");
                deadlineObj.PreDeadlines.push(MultiplePreDeadline);
            }
            if (Number(moment(deadlineObj.PreDeadline).format("YYYYMMDD")) > Number(moment(deadlineObj.Deadline).format("YYYYMMDD"))) {
                $("#" + this.PregiID).closest('.form-group').addClass("has-error");
                this.isAfterFrist(true);
                return;
            }
            else {
                this.isAfterFrist(false);
                $("#" + this.PregiID).closest('.form-group').removeClass("has-error");
            }
            const now = Number(moment(moment.now()).format("YYYYMMDD"));
            const deadlineBeforeToday = now > Number(moment(deadlineObj.Deadline).format("YYYYMMDD"));
            const predeadBeforeToday = now > Number(moment(deadlineObj.PreDeadline).format("YYYYMMDD"));
            const anyMultiPreBeforeToday = deadlineObj.PreDeadlines && deadlineObj.PreDeadlines.some(d => {
                const num = Number(moment(d, "YYYY-MM-DD").format("YYYYMMDD"));
                return now > num;
            });
            if ((deadlineBeforeToday || predeadBeforeToday || anyMultiPreBeforeToday) && ko.toJS(this.pastFristApproved()) === false) {
                $("#" + ko.toJS(this.givenId) + "Deadline_Body").removeClass("show");
                $("#" + ko.toJS(this.givenId) + "Deadline_Body").addClass("hide");
                $("#" + ko.toJS(this.givenId) + "approvePastDeadlineBody").removeClass("hide");
                $("#" + ko.toJS(this.givenId) + "approvePastDeadlineBody").addClass("show");
                return;
            }
            else {
                this.pastFristApproved(false);
            }
            try {
                (<HTMLButtonElement>document.getElementById(ko.toJS(this.givenId) + 'postFristBtn')).disabled = true;
                deadlineObj.stackId = ko.toJS(this.stackId);
                if (ko.toJS(this.fKAId) !== '') {
                    (<HTMLButtonElement>document.getElementById(ko.toJS(this.givenId) + 'exportToFKA')).disabled = true;
                    (<HTMLButtonElement>document.getElementById(ko.toJS(this.givenId) + 'notifyClerk')).disabled = true;
                }
                deadlineObj.MailMessageId = ko.toJS(this.currentMailMessageId);
                deadlineObj.AttachmentId = ko.toJS(this.currentAttachmentId);
                deadlineObj.stackId = ko.toJS(this.stackId);
                this.showOutlookLoader(true);
                await RNSAPI.createDeadline(deadlineObj).then((response) => {
                    let result = response as any;
                    this.savedSuccessfull(true);
                    this.showOutlookLoader(false);
                    if (result.OutlookExport === "SUCCESS") {
                        this.showError(false);
                        this.showSuccess(true);
                    }
                    else if (result.OutlookExport === "FAILURE") {
                        this.showSuccess(false);
                        this.showError(true);
                    }
                    else {
                        this.showError(false);
                        this.showSuccess(false);
                    }
                    setTimeout(() => {
                        if (!ko.toJS(this.showError)) {
                            if (ko.toJS(this.viewWithoutModal) === false) {
                                let idname = "#" + this.givenId;
                                $(idname).modal("hide");
                                if (!window.location.href.includes('new')) {
                                    this.akteFrist().CaseId("");
                                    this.akteFrist().Rubrum("");
                                }
                            }
                            this.akteFrist().DeadlineText("");
                            this.akteFrist().Notizen("");
                            this.deadlineCreationDate(moment().format("YYYY-MM-DD"));
                            this.deadlineNr("");
                            this.PreDeadlines([]);
                            this.PreDeadlinesLength(0);
                            RNSAPI.createHistoryEntry(deadlineObj.CaseId, "Frist angelegt");
                            (<HTMLButtonElement>document.getElementById(ko.toJS(this.givenId) + 'postFristBtn')).disabled = false;
                            this.savedSuccessfull(false);
                            if (window.location.href.endsWith('tfw') || window.location.href.includes('new'))
                                Postbox.publisher().publish("", "updateTFW");
                            this.infoTitle('Erledigt');
                            this.infoMessage('Daten erfolgreich erfasst.');
                            setTimeout(() => {
                                $('#messageModal').modal('hide');
                            }, 3000);
                            if (ko.toJS(this.isStack)) {
                                let dateOfEntry = "";
                                try {
                                    dateOfEntry = ko.toJS(moment(ko.toJS(deadlineObj.Deadline)).format("DD.MM.YYYY"));
                                }
                                catch {
                                }
                                Postbox.publisher().publish({
                                    index: ko.toJS(this.stackIndex),
                                    dateOfEntry: dateOfEntry,
                                    id: result.Id
                                }, "CreatedEntryInStack");
                                PostboxPaging.publisher().publish("", "GetEntriesInStackCreation");
                            }
                            else {
                                if (ko.toJS(this.viewWithoutModal) === false) {
                                    this.infoTitle('Erledigt');
                                    this.infoMessage('Daten erfolgreich erfasst.');
                                    setTimeout(() => {
                                        $('#messageModal').modal('hide');
                                    }, 3000);
                                }
                                else
                                    PostboxPaging.publisher().publish("", "GetEntriesInStackCreation");
                            }
                            if (ko.toJS(this.givenId) === 'EasyCaseNewDeadlineDialogExt') {
                                $("html, body").animate({ scrollTop: 0 }, "fast");
                                window.location.reload();
                            }
                            this.showError(false);
                        }
                        this.showOutlookLoader(false);
                        this.showSuccess(false);
                        if (ko.toJS(this.fKAId())) {
                            (<HTMLButtonElement>document.getElementById(ko.toJS(this.givenId) + 'exportToFKA')).disabled = false;
                            (<HTMLButtonElement>document.getElementById(ko.toJS(this.givenId) + 'notifyClerk')).disabled = false;
                        }
                    }, 2000);
                }).catch((error) => {
                    (<HTMLButtonElement>document.getElementById(ko.toJS(this.givenId) + 'postFristBtn')).disabled = false;
                    if (ko.toJS(this.fKAId())) {
                        (<HTMLButtonElement>document.getElementById(ko.toJS(this.givenId) + 'exportToFKA')).disabled = false;
                        (<HTMLButtonElement>document.getElementById(ko.toJS(this.givenId) + 'notifyClerk')).disabled = false;
                    }
                    console.log(error);
                    this.infoTitle('');
                    this.infoTitle('Fehler');
                    this.infoMessage('');
                    this.infoMessage('Fehler beim Anlegen der Frist.');
                    $('#messageModal').modal('show');
                });
            }
            catch (e) {
                (<HTMLButtonElement>document.getElementById(ko.toJS(this.givenId) + 'postFristBtn')).disabled = false;
                if (ko.toJS(this.fKAId())) {
                    (<HTMLButtonElement>document.getElementById(ko.toJS(this.givenId) + 'exportToFKA')).disabled = false;
                    (<HTMLButtonElement>document.getElementById(ko.toJS(this.givenId) + 'notifyClerk')).disabled = false;
                }
                console.log(e);
                this.infoTitle('');
                this.infoTitle('Fehler');
                this.infoMessage('');
                this.infoMessage('Fehler beim Anlegen der Frist.');
                $('#messageModal').modal('show');
            }
        }
        catch (e) {
            console.log(e);
        }
    }
    addPreDeadline(calculatedPredeadline) {
        let preDeadline = ko.observable(moment().format("YYYY-MM-DD"));
        let message = "";
        if (!calculatedPredeadline) {
            if (this.akteFrist().PreDeadline)
                preDeadline = ko.observable(moment(ko.toJS(this.akteFrist().PreDeadline)).format("YYYY-MM-DD"));
        }
        else {
            preDeadline = ko.observable(moment(calculatedPredeadline.CalculatedDate).format("YYYY-MM-DD"));
            if (calculatedPredeadline.RawDate !== calculatedPredeadline.CalculatedDate)
                message = "Verlegt vom " + moment(calculatedPredeadline.RawDate).format("DD.MM.yyyy");
        }
        let newPreDeadline = {
            PreDeadline: preDeadline,
            Message: ko.observable(message)
        };
        this.PreDeadlines.push(newPreDeadline);
        this.PreDeadlinesLength(this.PreDeadlines().length);
    }
    removePreDeadline(index) {
        this.PreDeadlines.splice(index, 1);
        this.PreDeadlinesLength(this.PreDeadlines().length);
    }
    workDayOffset(startDate, endDate) {
        let startWeekDay = startDate.clone();
        if (startDate.day() != 0) {
            startWeekDay = startWeekDay.subtract(startDate.day(), 'day');
        }
        else {
            startWeekDay = startWeekDay.subtract(1, 'w');
        }
        let endWeekDay = endDate.clone();
        if (endDate.day() != 0) {
            endWeekDay = endWeekDay.add(7 - endDate.day(), 'day');
        }
        let diff = endWeekDay.diff(startWeekDay, 'days');
        let weekends = 2 * (Math.floor(diff / 7) - 1);
        return weekends;
    }
    ;
    checkFunctions() {
        setTimeout(() => {
            if (this.isSelected() && !this.openedModal())
                this.pickCase();
        }, 200);
    }
    openedModal = ko.observable(false);
    navigateToCase() {
        $("#" + this.givenId).modal("hide");
        MainViewModel.RoutingTable.showNewView({ caseId: ko.toJS(this.akteFrist().CaseId) });
    }
    async pickCase() {
        this.openedModal(true);
        Postbox.publisher().publish("", "ResetDialogFilterOption");
        let cases = [];
        await RNSAPI.getCasesOverview().then((data) => {
            cases = data as any;
        }).catch((error) => {
            cases = [];
        });
        this.pickGeneric("Akte", ["caseid", "rubrum", "court_caseid_1", "refId"], ["Akte", "Rubrum", "AZ-Gericht 1. Instanz", "Standort"], cases);
        this.modalHandleSelection(async (selectedObject) => {
            this.akteFrist().CaseId(selectedObject()["caseid"]);
            let resCase = (await RNSAPI.getExtendedCase(ko.toJS(this.akteFrist().CaseId))).Payload;
            let res = resCase.Akte;
            this.akteFrist().Rubrum(res.Rubrum);
            this.gerCase('');
            if (res.Gericht1Id !== null && res.Gericht1Id !== '') {
                this.gerCase(res.Gericht1Id);
            }
            if (res.Gericht2Id !== null && res.Gericht2Id !== '') {
                this.gerCase(res.Gericht2Id);
            }
            if (res.Gericht3Id !== null && res.Gericht3Id !== '') {
                this.gerCase(res.Gericht3Id);
            }
            this.InstanceInCase(resCase.Instances);
            if (resCase.Instances.length > 0) {
                this.akteFrist().InstanceId(resCase.Instances[resCase.Instances.length - 1].InstanceId);
                this.showErrorOfInstances(false);
                (<HTMLButtonElement>document.getElementById(ko.toJS(this.givenId) + 'postFristBtn')).disabled = false;
            }
            else {
                (<HTMLButtonElement>document.getElementById(ko.toJS(this.givenId) + 'postFristBtn')).disabled = true;
                this.showErrorOfInstances(true);
            }
            this.attendeesOfSBs(res.WeitereSachbearbeiterRecords);
            if (ko.toJS(this.gerCase) !== '') {
                this.setBL();
            }
            this.getFKA();
        });
        $("#Deadmodal").modal("show");
        this.openedModal(false);
    }
    async getSBs(caseId: string) {
        let res = (await RNSAPI.getExtendedCase(caseId)).Payload;
        this.attendeesOfSBs(res.WeitereSachbearbeiterRecords);
    }
    async setBL() {
        var state = (await RNSAPI.GetStateByGerId(ko.toJS(this.gerCase))).Payload.state;
        this.akteFrist().State(state);
    }
    async setBLInstance(gerId) {
        var state = (await RNSAPI.GetStateByGerId(gerId)).Payload.state;
        this.setState(state);
    }
    async setFixBL() {
        var state = RNSAPI.getCurrentLoggedInUser().StateForCalculation;
        this.setState(state);
    }
    setState(state) {
        (<HTMLSelectElement>document.getElementById(ko.toJS(this.givenId) + "Bundesland")).value = state;
        this.akteFrist().State(state);
    }
    pickSachbearbeiter = async () => {
        Postbox.publisher().publish("", "ResetDialogFilterOption");
        let sachbearbeiter = (await RNSAPI.getSachbearbeiter()).Payload.Clerks.filter((s) => s.Sachbearbeiter_ID.trim() !== "");
        this.pickGeneric("Sachbearbeiter", ["Sachbearbeiter"], ["Sachbearbeiter"], sachbearbeiter);
        this.modalHandleSelection((selectedObject) => {
            this.akteFrist().SachbearbeiterId(selectedObject()["Sachbearbeiter_ID"]);
            this.akteFrist().Sachbearbeiter(selectedObject()["Sachbearbeiter_ID"]);
        });
        $("#Deadmodal").modal("show");
    };
    async pickDeadlineNumber() {
        Postbox.publisher().publish("", "ResetDialogFilterOption");
        let reasons = (await RNSAPI.getDeadlineReasons()).Payload.Reasons;
        reasons = reasons.filter((a) => (a.DeadlineNumber !== "We" && a.DeadlineNumber !== "WE")).sort((t1, t2) => {
            const name1 = t1.DeadlineDescription.toLowerCase();
            const name2 = t2.DeadlineDescription.toLowerCase();
            if (name1 > name2) {
                return 1;
            }
            if (name1 < name2) {
                return -1;
            }
            return 0;
        });
        if (ko.toJS(this.viewWithoutModal) === true) {
            Postbox.publisher().publish("", "ResetFilter");
            reasons = reasons.map((r) => {
                r.actionHandlers = [{
                        icon: "folder-download",
                        name: 'Fristgrund ausw\u00e4hlen',
                        action: async () => {
                            this.akteFrist().DeadlineNumber(r["DeadlineNumber"]);
                            this.deadlineNr(r["DeadlineDurationText"] + (r["PreDeadlineDurationText"] != "" ? " | " + r["PreDeadlineDurationText"] : ""));
                            this.isVerificationReason(r["DeadlineVerifcation"]);
                            this.calculateLikePreDeadline(r["CalculateLikePreDeadline"]);
                            this.akteFrist().DeadlineText(r["DeadlineDescription"]);
                            if (ko.toJS(this.deadlineNr) === '')
                                document.getElementById(ko.toJS(this.givenId) + 'deadlineDeadlineDate').removeAttribute('disabled');
                            else
                                document.getElementById(ko.toJS(this.givenId) + 'deadlineDeadlineDate').setAttribute('disabled', "");
                            this.navigateToDeadline();
                        },
                        isSelectionEvent: true
                    }];
                return r;
            });
            this.deadlineReasons(reasons);
            this.showDeadlineReasons(true);
        }
        else {
            this.pickGeneric("Grund", ["DeadlineDescription", "DeadlineDurationText", "PreDeadlineDurationText"], ["Beschreibung", "Fristdauer", "Vorfrist-Ablaufzeit"], reasons);
            this.modalHandleSelection((selectedObject) => {
                console.log(ko.toJS(selectedObject))
                this.akteFrist().DeadlineNumber(selectedObject()["DeadlineNumber"]);
                this.deadlineNr(selectedObject()["DeadlineDurationText"] + (selectedObject()["PreDeadlineDurationText"] != "" ? " | " + selectedObject()["PreDeadlineDurationText"] : ""));
                this.isVerificationReason(selectedObject()["DeadlineVerifcation"]);
                this.calculateLikePreDeadline(selectedObject()["CalculateLikePreDeadline"]);
                this.akteFrist().DeadlineText(selectedObject()["DeadlineDescription"]);
                if (ko.toJS(this.deadlineNr) === '')
                    document.getElementById(ko.toJS(this.givenId) + 'deadlineDeadlineDate').removeAttribute('disabled');
                else
                    document.getElementById(ko.toJS(this.givenId) + 'deadlineDeadlineDate').setAttribute('disabled', "");
            });
            $("#Deadmodal").modal("show");
        }
    }
    navigateToDeadline() {
        this.showDeadlineReasons(false);
    }
    async getDefaultSachbearbeiter() {
        let sach = (await RNSAPI.getSachbearbeiter()).Payload.Clerks.filter((d) => d.Sachbearbeiter_ID === RNSAPI.User().username);
        if (sach.length > 0) {
            this.akteFrist().Sachbearbeiter(sach[0].Sachbearbeiter_ID);
        }
    }
    async getFristenKalender(): Promise<any> {
        let result = { FKA: "", FKAId: "" };
        if (ko.toJS(this.akteFrist().CaseId) !== "" && ko.toJS(this.akteFrist().CaseId) !== null) {
            let res = (await RNSAPI.getExtendedCase(ko.toJS(this.akteFrist().CaseId))).Payload.Akte;
            result.FKA = res.DeadlineCalendarAccount;
            result.FKAId = res.DeadlineCalendarAccountId;
        }
        return result;
    }
    async getRubrumFromCase() {
        if (ko.toJS(this.akteFrist().CaseId) !== "") {
            let resCase = (await RNSAPI.getExtendedCase(ko.toJS(this.akteFrist().CaseId))).Payload;
            let res = resCase.Akte;
            this.akteFrist().Rubrum(res.Rubrum);
            this.gerCase('');
            if (res.Gericht1Id !== null && res.Gericht1Id !== '') {
                this.gerCase(res.Gericht1Id);
            }
            if (res.Gericht2Id !== null && res.Gericht2Id !== '') {
                this.gerCase(res.Gericht2Id);
            }
            if (res.Gericht3Id !== null && res.Gericht3Id !== '') {
                this.gerCase(res.Gericht3Id);
            }
            this.InstanceInCase(resCase.Instances);
            if (resCase.Instances.length > 0) {
                this.akteFrist().InstanceId(resCase.Instances[resCase.Instances.length - 1]).InstanceId;
                if (ko.toJS(this.instanceIdFromParameter)) {
                    let ins = ko.toJS(this.InstanceInCase);
                    ins = ins.filter(f => f.InstanceId === ko.toJS(this.instanceIdFromParameter));
                    this.akteFrist().InstanceId(ins[0].InstanceId);
                }
                this.showErrorOfInstances(false);
                (<HTMLButtonElement>document.getElementById(ko.toJS(this.givenId) + 'postFristBtn')).disabled = false;
            }
            else {
                try {
                    (<HTMLButtonElement>document.getElementById(ko.toJS(this.givenId) + 'postFristBtn')).disabled = true;
                }
                catch { }
                this.showErrorOfInstances(true);
            }
            this.attendeesOfSBs(res.WeitereSachbearbeiterRecords);
            if (ko.toJS(this.gerCase) !== '') {
                this.setBL();
            }
        }
    }
    async getFKA() {
        let AccountId = await this.getFristenKalender();
        let result = (await RNSAPI.getOutlook());
        if (result.Type === "GetAccountsSuccessful") {
            let res = result.Payload.OutlookAccounts;
            if (res.length > 0) {
                let account = "";
                let accountId = "";
                for (let acc of res) {
                    if (acc.OutlookAccountID === AccountId.FKAId) {
                        account = acc.UserLogin;
                        accountId = acc.OutlookAccountID;
                    }
                }
                if (account === "") {
                    account = res[0].UserLogin;
                    accountId = res[0].OutlookAccountID;
                }
                this.fkAName(account);
                this.fKAId(accountId);
            }
            let user = RNSAPI.getCurrentLoggedInUser();
            if (user.UseVerificationWorkflow === "1" && user.LawFirmId !== "100154") {
                if (document.getElementById(ko.toJS(this.givenId) + 'notifyClerk'))
                    (<HTMLButtonElement>document.getElementById(ko.toJS(this.givenId) + 'notifyClerk')).removeAttribute("checked");
            }
        }
    }
    constructor(params: any) {
        if (params.Case) {
            this.akteFrist().CaseId(params.Case);
            this.getRubrumFromCase();
        }
        if (params.prefix) {
            this.givenId = params.prefix + this.givenId;
            this.PregiID = params.prefix + this.PregiID;
        }
        if (params.isStack) {
            this.isStack(params.isStack);
            if (params.stackId)
                this.stackId(ko.toJS(params.stackId));
        }
        if (params.showWithoutModal)
            this.viewWithoutModal(params.showWithoutModal);
        if (params.CaseId) {
            this.akteFrist().CaseId(ko.toJS(params.CaseId));
            if (params.InstanceId)
                this.instanceIdFromParameter(ko.toJS(params.InstanceId));
            this.getRubrumFromCase();
            if (params.MailMessageId)
                this.currentMailMessageId(ko.toJS(params.MailMessageId));
            if (params.AttachmentId)
                this.currentAttachmentId(ko.toJS(params.AttachmentId));
        }
        if (params.note)
            this.akteFrist().Notizen(ko.toJS(params.note));
        if (params.typeId)
            this.akteFrist().DeadlineNumber(ko.toJS(params.typeId));
        if (params.stackIndex)
            this.stackIndex(ko.toJS(params.stackIndex));
        if (params.referenceDate)
            this.akteFrist().Deadline(ko.toJS(params.referenceDate));
        if (params.calculatedDates) {
            this.calculatedDates(ko.toJS(params.calculatedDates));
            this.deadlineCreationDate(moment(ko.toJS(this.calculatedDates).ReferenceDate).format("YYYY-MM-DD"));
        }
        Postbox.publisher().subscribe((CaseID) => {
            this.akteFrist().CaseId(CaseID);
            this.getRubrumFromCase();
            this.getFKA();
        }, "SetCaseID");
        this.akteFrist().InstanceId.subscribe(() => this.setParamsForInstance());
        this.akteFrist().State.subscribe(() => this.calulateFristWithParameters());
        if (ko.toJS(this.isStack) === false)
            this.akteFrist().DeadlineText.subscribe(() => this.calulateFristWithParameters());
        this.akteFrist().Deadline.subscribe(() => this.calulateFristWithDeadline());
        if (ko.toJS(this.isStack) === false)
            this.deadlineCreationDate.subscribe(() => this.calulateFristWithParameters());
        this.isSelected.subscribe(() => this.checkFunctions());
        this.getDefaultSachbearbeiter();
        this.getFKA();
    }
}
let html = fs.readFileSync(__dirname + "/deadlineDialog.html", "utf8");
ko.components.register("deadline-dialog-view", {
    viewModel: resubmissionDialogViewModel,
    template: html,
});
